"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSortableTree = _interopRequireWildcard(require("react-sortable-tree"));

require("react-sortable-tree/style.css");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _faSave = require("@fortawesome/pro-regular-svg-icons/faSave");

var _faEdit = require("@fortawesome/pro-regular-svg-icons/faEdit");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faExclamationTriangle = require("@fortawesome/pro-regular-svg-icons/faExclamationTriangle");

var _client = require("@peracto/client");

var _peractoUi = require("@peracto/peracto-ui");

var _reactToastify = require("react-toastify");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _NavigationTreeForm = _interopRequireDefault(require("./NavigationTreeForm"));

var _NavigationTreeRow = _interopRequireDefault(require("./NavigationTreeRow"));

var _NavigationTreeEmpty = _interopRequireDefault(require("./NavigationTreeEmpty"));

var _util = require("../../NavigationEdit/util");

var S = _interopRequireWildcard(require("./styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CHILDESS_TYPES = ['directLink'];
var CONTENT_TYPES = ['page', 'article'];

var NavigationTree = function NavigationTree(_ref) {
  var values = _ref.values,
      menuCode = _ref.menuCode,
      onSaveOrder = _ref.onSaveOrder,
      _ref$savingOrder = _ref.savingOrder,
      savingOrder = _ref$savingOrder === void 0 ? false : _ref$savingOrder;

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var _useState = (0, _react.useState)(values),
      _useState2 = _slicedToArray(_useState, 2),
      treeData = _useState2[0],
      setTreeData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAddModal = _useState4[0],
      setShowAddModal = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDeleteModal = _useState6[0],
      setShowDeleteModal = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      modalData = _useState8[0],
      setModalData = _useState8[1];

  var onSubmitForm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data, actions) {
      var parent, parsedData, method, options, isUpdate, response, _e$error, _e$error$body;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              parent = null;

              if (modalData !== null && modalData !== void 0 && modalData.parent) {
                parent = modalData.parent['@id'];
              }

              _context.prev = 2;
              parsedData = _objectSpread(_objectSpread({}, data), {}, {
                parent: parent,
                menuCode: menuCode,
                displayFrom: data.displayFrom ? (0, _dayjs["default"])(data.displayFrom).format() : null,
                displayTo: data.displayTo ? (0, _dayjs["default"])(data.displayTo).format() : null,
                itemType: CONTENT_TYPES.includes(data.itemType) ? 'content' : data.itemType
              });

              if (!parent) {
                delete parsedData.parent;
              } // Branches don't require a path and the API can't handle a null path


              if (parsedData.itemType === 'branch' && (parsedData === null || parsedData === void 0 ? void 0 : parsedData.path) === null) {
                delete parsedData.path;
              }

              method = _client.CREATE;
              options = {
                data: parsedData
              };
              isUpdate = data.hasOwnProperty('@id'); // Item can only have '@id' if it's an existing item

              if (isUpdate) {
                method = _client.UPDATE;
                options.id = data['@id'];
                delete parsedData.parent; // we don't need to pass the parent when updating
              }

              _context.next = 12;
              return client(method, 'menu-items', options);

            case 12:
              response = _context.sent;

              if (modalData.path) {
                if (isUpdate) {
                  // UPDATE existing node
                  setTreeData((0, _reactSortableTree.changeNodeAtPath)({
                    treeData: treeData,
                    path: modalData.path,
                    getNodeKey: getNodeKey,
                    newNode: (0, _util.convertToTreeData)(data)
                  }));
                } else {
                  // CREATE new node as child
                  setTreeData((0, _reactSortableTree.addNodeUnderParent)({
                    treeData: treeData,
                    parentKey: modalData.path[modalData.path.length - 1],
                    expandParent: true,
                    getNodeKey: getNodeKey,
                    newNode: (0, _util.convertToTreeData)(response.data),
                    addAsFirstChild: false
                  }).treeData);
                }
              } else {
                // CREATE new node at root
                setTreeData([].concat(_toConsumableArray(treeData), [(0, _util.convertToTreeData)(response.data)]));
              }

              _reactToastify.toast.success("Item successfully ".concat(isUpdate ? 'updated' : 'added', "!"));

              actions.setSubmitting(false);
              actions.resetForm();
              setShowAddModal(false);
              setModalData({});
              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

              _reactToastify.toast.error(_context.t0 !== null && _context.t0 !== void 0 && (_e$error = _context.t0.error) !== null && _e$error !== void 0 && (_e$error$body = _e$error.body) !== null && _e$error$body !== void 0 && _e$error$body.hasOwnProperty('hydra:description') ? _context.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

              actions.setSubmitting(false);

            case 26:
              setShowAddModal(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 21]]);
    }));

    return function onSubmitForm(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onDelete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _e$error2, _e$error2$body;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return client(_client.DELETE, 'menu-items', {
                id: "/menu-items/".concat(modalData.node.originId || modalData.node.id)
              });

            case 3:
              setTreeData((0, _reactSortableTree.removeNodeAtPath)({
                treeData: treeData,
                path: modalData.path,
                getNodeKey: getNodeKey
              }));

              _reactToastify.toast.success("".concat(modalData.title || 'Menu item', " deleted successfully!"));

              setModalData(null);
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

              _reactToastify.toast.error(_context2.t0 !== null && _context2.t0 !== void 0 && (_e$error2 = _context2.t0.error) !== null && _e$error2 !== void 0 && (_e$error2$body = _e$error2.body) !== null && _e$error2$body !== void 0 && _e$error2$body.hasOwnProperty('hydra:description') ? _context2.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    return function onDelete() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    setTreeData(values);
  }, [values]);

  var getNodeKey = function getNodeKey(_ref4) {
    var treeIndex = _ref4.treeIndex;
    return treeIndex;
  };

  if (treeData) {
    var _modalData$node;

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(S.NavigationTree, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex justify-content-between align-items-center mb-2"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary",
      onClick: function onClick() {
        setModalData({});
        setShowAddModal(true);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faPlusCircle.faPlusCircle,
      className: "mr-2"
    }), "Add Item"), /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-success ml-2 ".concat(savingOrder && 'btn-disabled'),
      onClick: function onClick(e) {
        e.preventDefault();
        onSaveOrder(_toConsumableArray(treeData));
      },
      disabled: savingOrder || treeData.length === 0
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faSave.faSave,
      className: "mr-2"
    }), savingOrder ? 'Saving...' : 'Save Display Order')), treeData.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '80vh',
        minHeight: '400px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactSortableTree["default"], {
      isVirtualized: false,
      treeData: treeData,
      onChange: function onChange(treeData) {
        return setTreeData(treeData);
      },
      nodeContentRenderer: _NavigationTreeRow["default"],
      canNodeHaveChildren: function canNodeHaveChildren(node) {
        return node && !CHILDESS_TYPES.includes(node.itemType);
      },
      generateNodeProps: function generateNodeProps(_ref5) {
        var node = _ref5.node,
            path = _ref5.path;
        var buttons = [/*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-link text-info",
          title: "Edit Menu Item",
          onClick: function onClick() {
            setModalData({
              node: node,
              path: path
            });
            setShowAddModal(true);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _faEdit.faEdit
        })), /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-link text-danger",
          title: "Remove Item",
          onClick: function onClick() {
            setModalData({
              node: node,
              path: path
            });
            setShowDeleteModal(true);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _faTrash.faTrash
        }))]; // If the menu item supports children then add the 'Add Child'
        // button between the edit/delete buttons

        if (!CHILDESS_TYPES.includes(node === null || node === void 0 ? void 0 : node.itemType)) {
          buttons.splice(1, 0, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-link",
            title: "Add Child",
            onClick: function onClick() {
              setModalData({
                node: null,
                path: path,
                parent: node
              });
              setShowAddModal(true);
            }
          }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _faPlusCircle.faPlusCircle
          })));
        }

        return {
          buttons: buttons
        };
      }
    })) : /*#__PURE__*/_react["default"].createElement(_NavigationTreeEmpty["default"], {
      setShowAddModal: setShowAddModal,
      setModalData: setModalData
    })), /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
      isVisible: showAddModal,
      title: "".concat(modalData !== null && modalData !== void 0 && modalData.node ? 'Edit' : 'Add', " Menu Item"),
      close: function close() {
        return setShowAddModal(false);
      }
    }, showAddModal && /*#__PURE__*/_react["default"].createElement(_NavigationTreeForm["default"], {
      values: (modalData === null || modalData === void 0 ? void 0 : modalData.node) || {},
      parent: modalData === null || modalData === void 0 ? void 0 : modalData.parent,
      onSubmitForm: onSubmitForm,
      childessTypes: CHILDESS_TYPES,
      onClose: function onClose() {
        return setShowAddModal(false);
      }
    })), /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
      isVisible: showDeleteModal,
      title: "Delete Menu Item",
      close: function close() {
        return setShowDeleteModal(false);
      },
      buttons: [{
        type: 'btn-outline-secondary',
        text: 'Close',
        action: function action() {
          setShowDeleteModal(false);
        }
      }, {
        type: 'btn-danger',
        text: 'Delete',
        action: function action() {
          setShowDeleteModal(false);
          onDelete();
        }
      }]
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faExclamationTriangle.faExclamationTriangle,
      size: "4x",
      className: "d-block mb-4"
    }), "Are you sure you would like to remove ".concat((modalData === null || modalData === void 0 ? void 0 : (_modalData$node = modalData.node) === null || _modalData$node === void 0 ? void 0 : _modalData$node.title) || 'this item', " from the menu?")));
  }

  return 'Loading...';
};

var _default = NavigationTree;
exports["default"] = _default;